import KendoChartBase from '../KendoChartBase'


export default {
    mixins: [
        KendoChartBase
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoChart(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChart/KendoChartMixin.js